import React from 'react';
var ComponentOverridesContext = /*#__PURE__*/React.createContext({});
ComponentOverridesContext.displayName = 'ComponentOverridesContext';
var ComponentOverridesConsumer = ComponentOverridesContext.Consumer;
var useComponentOverridesProvider = () => React.useContext(ComponentOverridesContext);
var ComponentOverridesProvider = _ref => {
  var {
    value,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(ComponentOverridesContext.Provider, {
    value: value
  }, children);
};
ComponentOverridesProvider.displayName = 'ComponentOverridesProvider';
export { ComponentOverridesConsumer, ComponentOverridesProvider, useComponentOverridesProvider };
//# sourceMappingURL=index.js.map